import React from 'react';
import { Button } from '@base/lib/Button';
import type { ITabsItem } from 'mod/feature/interface';
import cn from 'classnames';
import { Banner } from 'mod/featureV2/Banner';
import { isVideoUrl } from 'base/utils/file';

type IProps = {
    tabItem?: ITabsItem;
    className?: string;
    bannerProps?: {
        width?: number;
        height?: number;
    }
}

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

export const BannerText: React.FC<IProps> = (props) => {

    const { tabItem, bannerProps = {}, className } = props

    const { banner, title, description, button } = tabItem || {}

    const {
        width,
        height,
    } = bannerProps;

    const bannerWidth = bannerProps.width || 716
    const bannerHeight = height ? height : (
        banner && isVideoUrl(banner?.src) ? 358 : 0  // 图片 0 为图片自身比例展示
    );

    return (
        <div className={cn(className, 'flex g-banner-text-wrap flex-middle')}>
            {/* 文案 */}
            <div className={'g-text-wrap'}>
                <div>
                    {title && (
                        <p className={'g-title'}>{title?.text}</p>
                    )}
                    {description && (
                        <p className={'g-description'}>{description?.text}</p>
                    )}
                    {button?.button && (
                        <Button
                            href={button.linkUrl}
                            className={'g-button'}
                            type={'primary'}
                            size={'large'}
                            shape={isPhone ? 'default' : 'round'}
                        >
                            {button.button}
                        </Button>
                    )}
                </div>
            </div>

            {/* 背景图 */}
            {banner && (
                <div className={'g-banner-wrap'}>
                    <Banner
                        banner={banner}
                        width={bannerWidth}
                        height={bannerHeight}
                    />
                </div>
            )}
        </div>
    );
};